module.exports = new __parcel__URL__("cornershop-shopper-android.8ac62481.webp").toString();